import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'

export class ExtramuralService extends BaseService<unknown> {
  constructor() {
    super({
      baseUrl: 'extramural'
    })
  }
  async downloadBackupDB(): Promise<AxiosResponse<ArrayBuffer>> {
    return this.http.get<ArrayBuffer>('sync/downloadBackupDB',{
      responseType: 'arraybuffer',
      headers: {
        'Access-Control-Max-Age': '0'
      }
    })
  }
}